"use strict";
/* eslint-disable import/no-cycle, camelcase */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../../rest"));
var lessonsApi_1 = require("../../mock/lessonsApi");
var combineLearningPanelFreeUrl_1 = __importDefault(require("./combineLearningPanelFreeUrl"));
var LessonsApi = {
    getLessonsCompletedUuids: function () {
        return rest_1.default.get({
            mockFunc: function () { return lessonsApi_1.mockCompletedLessonUuids; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/lessons/completed-lessons'),
        });
    },
};
exports.default = LessonsApi;
